import InboxIcon from "@mui/icons-material/MoveToInbox";
import HandshakeOutlinedIcon from "@mui/icons-material/HandshakeOutlined";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import SavingsOutlinedIcon from "@mui/icons-material/SavingsOutlined";
import CompareOutlinedIcon from "@mui/icons-material/CompareOutlined";
//import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
// import DataThresholdingIcon from "@mui/icons-material/DataThresholding";
import SettingsIcon from "@mui/icons-material/Settings";
import WebAssetIcon from "@mui/icons-material/WebAsset";
import AdsClickIcon from "@mui/icons-material/AdsClick";
import HowToVoteIcon from "@mui/icons-material/HowToVote";
export interface SubItemMenuConfigModule {
  label: string;
  icon: any;
  path: string;
  permissions: string[] | null;
}

export interface ItemMenuConfigModule {
  label: string;
  icon: any;
  path: string;
  permissions: string[] | null;
  children: SubItemMenuConfigModule | null;
}

export interface MenuConfigModule {
  label: string;
  icon: any;
  path: string;
  permissions: string[] | null;
  children: ItemMenuConfigModule | null;
}

// const isStaging = import.meta.env.VITE_ENV === "staging";
// const development = import.meta.env.VITE_ENV === "development";

export const MENU_CONFIG = [
  {
    label: "assets",
    icon: <WebAssetIcon />,
    path: "#",
    children: [
      {
        label: "page_builder",
        permission: ["view_page_content", "view_pages_list"],
        icon: <InboxIcon />,
        path: "/assets/page_builder",
      },
      {
        label: "websites",
        icon: <InboxIcon />,
        path: "#",
        children: [
          {
            label: "page_groups",
            permission: ["view_page_groups"],
            icon: <InboxIcon />,
            path: "assets/websites/page_groups",
          },
          {
            label: "website_actions",
            permission: ["view_websites_list", "view_websites_groups"],
            icon: <InboxIcon />,
            path: "assets/websites/website_actions",
          },
        ],
      },
      {
        label: "overview",
        icon: <InboxIcon />,
        path: "",
        children: [
          {
            label: "business_leader_dashboard",
            permission: [
              "view_business_leader_dashboard",
              "view_trends_dashboard",
            ],
            icon: <InboxIcon />,
            path: "assets/overview/business_leader_dashboard",
          },
          {
            label: "website_projection",
            permission: ["view_website_target"],
            icon: <InboxIcon />,
            path: "assets/overview/website_projection",
          },
          {
            label: "trends",
            permission: ["view_trends_dashboard"],
            icon: <InboxIcon />,
            path: "/assets/overview/trends/",
          },
          {
            label: "activity_notes",
            permission: ["view_activity_notes"],
            icon: <InboxIcon />,
            path: "assets/overview/activity_notes",
          },
          {
            label: "action_items",
            permission: ["view_action_items"],
            icon: <InboxIcon />,
            path: "assets/overview/action_items",
          },
          {
            label: "forecaster",
            permission: ["view_forecasters_history"],
            icon: <InboxIcon />,
            path: "assets/overview/forecaster",
          },
        ],
      },
      {
        label: "design",
        icon: <InboxIcon />,
        path: "#",
        children: [
          {
            label: "themes",
            permission: ["view_theme"],
            icon: <InboxIcon />,
            path: "assets/design/theme",
          },
          {
            label: "templates",
            permission: ["view_template"],
            icon: <InboxIcon />,
            path: "assets/design/templates",
          },
        ],
      },
      {
        label: "health",
        icon: <InboxIcon />,
        path: "#",
        children: [
          {
            label: "monitoring",
            permission: ["view_monitoring_dashboard"],
            icon: <InboxIcon />,
            path: "assets/health/monitoring",
          },
          {
            label: "page_speed_performance",
            permission: ["view_page_speed_performance", "view_psi_results"],
            icon: <InboxIcon />,
            path: "assets/health/page_speed_performance",
          },
          {
            label: "data_accuracy",
            permission: ["view_data_anomalies"],
            icon: <InboxIcon />,
            path: "assets/health/data_accuracy",
          },
        ],
      },
    ],
  },
  {
    label: "partners",
    icon: <HandshakeOutlinedIcon />,
    path: "/comingSoon",
  },
  {
    label: "paid_traffic",
    icon: <AdsClickIcon />,
    path: "#",
    children: [
      {
        label: "performance_analysis",
        icon: <InboxIcon />,
        path: "#",
        children: [
          {
            label: "insights",
            permission: ["view_paid_traffic_insights"],
            icon: <InboxIcon />,
            path: "/paidTraffic/performance_analysis/insights",
          },
        ],
      },
      {
        label: "advertising_accounts",
        permission: ["view_ads_accounts"],
        icon: <InboxIcon />,
        path: "/paidTraffic/advertising-accounts",
      },
      {
        label: "engagement_incentives",
        permission: [
          "view_incentivezed_traffic_performance",
          "view_monthly_budgets",
        ],
        icon: <InboxIcon />,
        path: "paidTraffic/engagement_incentives",
      },
      {
        label: "methodology",
        icon: <InboxIcon />,
        path: "#",
        children: [
          {
            label: "LP_experiences",
            permission: ["view_lp_experience_overview"],
            icon: <InboxIcon />,
            path: "/paidTraffic/methodology/landing_page_experience",
          },
          
          {
            label: "search_term_operations",
            permission: ["view_st_account_management"],
            icon: <InboxIcon />,
            path: "/paidTraffic/methodology/search_term_operations",
          },
        ],
      },
    ],
  },
  {
    label: "organic_traffic",
    icon: <SavingsOutlinedIcon />,
    path: "/comingSoon",
  },
  {
    label: "market_positioning",
    icon: <CompareOutlinedIcon />,
    path: "#",
    children: [
      {
        label: "scout",
        icon: <InboxIcon />,
        path: "#",
        children: [
          {
            label: "competitors_page_speed",
            permission: [
              "view_external_page_speed_performance",
              "view_external_psi_requests",
            ],
            icon: <InboxIcon />,
            path: "market_positioning/scout/competitors_page_speed",
          },
        ],
      },
    ],
  },
  {
    label: "finance",
    icon: <SavingsOutlinedIcon />,
    path: "#",
    children: [
      {
        label: "providers_expenses",
        icon: <InboxIcon />,
        path: "#",
        children: [
          {
            label: "manual_expenses",
            permission: ["view_manual_expenses"],
            icon: <InboxIcon />,
            path: "finance/providers_expenses/manual_expenses",
          },
           {
            label: "receipts",
            permission: ["view_receipts"],
            icon: <InboxIcon />,
            path: "finance/providers_expenses/receipts",
          },
        ],
      },
    ],
  },
  {
    label: "personal_settings",
    icon: <SettingsIcon />,
    path: "/comingSoon",
  },
  {
    label: "data_collection",
    icon: <HowToVoteIcon />,
    path: "#",
    children: [
      {
        label: "brands",
        permission: ["view_brands"],
        path: "data_collection/brands",
      },
       {
        label: "Brand Configuration Report",
        permission: ["view_brand_configurations"],
        path: "data_collection/brand_configuration_report",
      }, 
      {
        label: "Unifier",
        path: "#",
        children: [
          {
            label: "Maps",
            permission: ["view_maps"],
            path: "data_collection/unifier/maps",
          },
          {
            label: "Calculation Types",
            permission: ["view_calculation_types"],
            path: "data_collection/unifier/calculation_types",
          },
          {
            label: "Unique Definitions",
            permission: ["view_unique_definitions"],
            path: "data_collection/unifier/unique_definitions",
          },
        ],
      },
      {
        label: "Monitoring",
        icon: <InboxIcon />,
        path: "#",
        children: [
          {
            label: "Packages",
            permission: ["view_monitoring"],
            icon: <InboxIcon />,
            path: "data_collection/monitoring/packages",
          },
          {
            label: "Process Logs",
            permission: ["view_workflows"],
            icon: <InboxIcon />,
            path: "data_collection/monitoring/process_logs",
          },
        ],
      },
    ],
  },
  {
    label: "admin",
    icon: <AdminPanelSettingsIcon />,
    path: "#",
    children: [
      {
        label: "processes",
        icon: <InboxIcon />,
        path: "#",
        children: [
          {
            label: "etl_sequences",
            permission: ["view_etl_sequences"],
            icon: <InboxIcon />,
            path: "/admin/processes/etl-sequences",
          },
          {
            label: "etl_list",
            permission: ["view_processes_list"],
            icon: <InboxIcon />,
            path: "/admin/processes/etl-process-list",
          },
          {
            label: "etl_logs",
            permission: ["view_processes_logs", "view_process_log"],
            icon: <InboxIcon />,
            path: "/admin/processes/etl-process-log",
          },
        ],
      },
      {
        label: "meta_entities",
        permission: [
          "view_traffic_click_identifiers",
          "view_territories",
          "view_geos",
          "view_traffic_sources",
          "view_industries",
          "view_device_types",
          "view_products_types",
          "view_currency_symbols",
          "view_organizations",
          "view_format_types",
          "view_collection_methods",
          "view_collection_types",
        ],
        icon: <InboxIcon />,
        path: "/admin/meta_entities",
      },
      {
        label: "datastore_requests",
        icon: <InboxIcon />,
        path: "/admin/datastore_requests/",
        permission: ["view_datastore_requests"],
      },
    ],
  },
];
